// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XQZx","textarea":"styles_textarea__6PCL3"};